export const sellerOnboardingWorkflowMethods = {
    submitCurrentStep() {
        const actions = {
            profile: this.submitProfile,
            account: this.continueFromAccount,
            modules: this.finishOnboarding,
        };

        return actions[this.step]?.();
    },
    async loadState(initial = false) {
        try {
            this.applyState(await this.onboardingApi.loadState());

            if (initial) {
                this.resetModules();
                this.step = !this.state.authenticated ? 'profile' : 'account';
            }
        } catch (error) {
            this.handleError(error);
        } finally {
            this.loading = false;
        }
    },
    async submitProfile() {
        this.clearErrors();

        if (this.state.authenticated) {
            this.step = 'account';
            return;
        }

        this.sending = true;
        try {
            const state = await this.onboardingApi.submitProfile(this.profileMode, {...this.profileForm});

            this.applyState(state);
            this.profileForm.password = '';
            this.profileForm.password_confirmation = '';
            this.step = 'account';
        } catch (error) {
            this.handleError(error);
        } finally {
            this.sending = false;
        }
    },
    continueFromAccount() {
        this.clearErrors();

        if (!this.createNewAccount) {
            if (!this.selectedAccountId) {
                this.errors = {account_id: ['Выбери бизнес-аккаунт.']};
                return;
            }
            this.prepareSelectedAccount();
            this.step = 'modules';
            return;
        }

        const phone = this.accountForm.phone.replace(/\D/g, '');
        const inn = this.accountForm.inn.replace(/\D/g, '');
        const errors = {};

        if (!this.accountForm.name.trim()) {
            errors['account.name'] = ['Укажи название бизнес-аккаунта.'];
        }
        if (phone.length !== 11) {
            errors['account.phone'] = ['Телефон должен содержать 11 цифр.'];
        }
        if (inn.length < 10 || inn.length > 12) {
            errors['account.inn'] = ['ИНН должен содержать от 10 до 12 цифр.'];
        }

        if (Object.keys(errors).length) {
            this.errors = errors;
            return;
        }

        this.selectedShopId = null;
        this.createNewShop = true;
        this.step = 'modules';
    },
    async finishOnboarding() {
        this.clearErrors();

        if (!this.validateModules()) {
            return;
        }

        this.sending = true;
        try {
            const state = await this.onboardingApi.complete(this.completionPayload());

            this.selectedAccountId = state.account_id;
            this.selectedShopId = state.shop_id;
            this.selectedSellerId = state.seller_id;
            this.applyState(state);
            this.step = 'ready';
            this.persistDraft();
        } catch (error) {
            this.handleError(error);
            if (Object.keys(this.errors).some(key => key.startsWith('account.'))) {
                this.step = 'account';
            }
        } finally {
            this.sending = false;
        }
    },
    validateModules() {
        const errors = {};

        if (!this.selectedModules.length) {
            errors.modules = ['Выбери хотя бы один модуль.'];
        }

        if (this.moduleShop) {
            if (this.createNewShop && !this.canCreateShop) {
                errors.service_limit = ['В этом бизнес-аккаунте нельзя создать ещё один магазин.'];
            } else if (this.createNewShop && !this.shopForm.name.trim()) {
                errors['shop.name'] = ['Укажи название магазина.'];
            } else if (!this.createNewShop && !this.selectedShopId) {
                errors.shop_id = ['Выбери магазин.'];
            }
        }

        this.errors = errors;

        return Object.keys(errors).length === 0;
    },
    completionPayload() {
        const payload = {
            account_mode: this.createNewAccount ? 'new' : 'existing',
            account_id: this.createNewAccount ? null : this.selectedAccountId,
            account: this.createNewAccount ? {
                ...this.accountForm,
                name: this.accountForm.name.trim(),
                phone: this.accountForm.phone.replace(/\D/g, ''),
                inn: this.accountForm.inn.replace(/\D/g, ''),
                email: this.accountForm.email.trim() || null,
            } : null,
            modules: this.selectedModules,
            shop_mode: null,
            shop_id: null,
            shop: null,
        };

        if (this.moduleShop) {
            payload.shop_mode = this.createNewShop ? 'new' : 'existing';
            payload.shop_id = this.createNewShop ? null : this.selectedShopId;
            payload.shop = this.createNewShop ? {name: this.shopForm.name.trim()} : null;
        }

        return payload;
    },
};
